export function addMaskToPhone(number) {
  if ( /^[+][0-9]{12}$/.test(number) ) {
    let phone = number.match(/(\d{2})(\d{3})(\d{3})(\d{2})(\d{2})/)
    if (phone != null) {
      return `+${phone[1]}(${phone[2]})${phone[3]}-${phone[4]}-${phone[5]}`
    }
  }
  return number
}
